import {ModalitaPagamentoVagliaForm} from "../../models/form/modalita-pagamento-vaglia-form.model";

export const modalitaPagamentoVagliaFormDefaults: ModalitaPagamentoVagliaForm = {
	nome: null,
	cognome: null,
	email: null,
	pec: null,
	telefono: null,
	intestatoSudioLegale: false,
	domicilioRichiedenteCoincideConResidenza: false
}
